import * as React from "react";
import Svg, { Path } from "react-native-svg";

function NoOrdersGraphic(props) {
  return (
    <Svg width={240} height={152} viewBox="0 0 240 152" fill="none" {...props}>
      <Path
        d="M184.722 114.128c9.872-24.681 6.885-52.24-5.847-73.405L45.597 59.176 173.32 32.558C119.49-34.568 14.718 9.956 24.818 94.708l159.904 19.42z"
        fill="#E6E6E6"
      />
      <Path d="M190.6 86.845H20.802v52.874H190.6V86.845z" fill="#E40046" />
      <Path
        d="M68.156 80.398c1.524 1.183 2.081 1.565 2.405 1.516 15.72 4.578 1.94 9.942-5.698.836l3.293-2.352zM16.288 128.758v10.747l7.738-.43-2.15-11.177-5.588.86zM59.274 128.758v10.747l-7.737-.43 2.149-11.177 5.588.86z"
        fill="#FFB8B8"
      />
      <Path
        d="M35.632 73.303l11.607-.43c26.774 28.07 16.649 21.668 15.905 60.182l-14.186-4.298 3.01-26.652c0-.001.793-.53.134-.542-4.118 1.416-7.123-16.108-16.04-14.074-10.147-.485-11.799 14.567-15.905 14.616l3.009 26.652-14.186 4.298C7.392 90.732-.392 100.293 24.885 72.874l10.747.43zM18.437 136.065s-1.72-3.439-3.869-1.719c-2.15 1.719-7.308 6.878-7.308 6.878s-12.466 5.588-4.728 9.027c7.738 3.439 14.186-4.729 14.186-4.729 7.37-1.537 11.62-2.521 7.712-10.56-2.219.961-5.359 2.072-5.993 1.103zM57.125 136.065s1.72-3.439 3.869-1.719c2.15 1.719 7.308 6.878 7.308 6.878s12.466 5.588 4.728 9.027c-7.737 3.439-14.186-4.729-14.186-4.729-7.37-1.537-11.62-2.521-7.712-10.56 2.219.961 5.359 2.072 5.993 1.103z"
        fill="#2F2E41"
      />
      <Path
        d="M47.238 24.73c-.639 10.701-15.244 9.76-15.475 0 .64-10.701 15.244-9.759 15.475 0z"
        fill="#FFB8B8"
      />
      <Path
        d="M36.062 30.318c3.76 11.366-5.118 5.178 7.308 14.186l4.728-9.458s-3.439-1.29-3.009-6.018l-9.027 1.29z"
        fill="#FFB8B8"
      />
      <Path
        d="M59.275 36.766L46.46 33.84c.36 7.727-7.886 6.172-9.325 2.285l-12.25 7.088c5.142 19.152 3.838 19.942-3.01 32.24-2.613 2.387 1.295 3.755 4.698 2.449 2.595-1.602 3.913-3.026 6.694-2.663 13.14 2.736 24.08 3.382 25.81 2.312.62-.886-.018-40.632.197-40.786z"
        fill="#FFB800"
      />
      <Path
        d="M55.836 37.626c.43 0 2.644-1.04 2.644-1.04 6.442-.11 10.765 43.225 11.111 44.457l-4.298 3.01-6.878-17.625-2.58-28.802z"
        fill="#FFB800"
      />
      <Path
        d="M25.745 87.92c.22 1.623.594 19.841 7.12 11.33.856-6.208-2.055-8.062-2.821-12.19l-4.299.86z"
        fill="#FFB8B8"
      />
      <Path
        d="M27.464 43.214l-1.317-.73c-3.531-.116-2.418 9.231-3.912 16.077-1.221 7.974-.873 16.767.559 28.523.125 4.314 7.851 1.596 8.969 1.267 0 0-2.58-17.625-1.29-20.634 1.29-3.01-3.01-24.503-3.01-24.503z"
        fill="#FFB800"
      />
      <Path
        d="M46.9 17.229a9.222 9.222 0 00-5.246-4.01L40.05 14.5l.624-1.496a8.485 8.485 0 00-1.586-.092l-1.443 1.856.597-1.792c-6.192.665-9.856 7.773-6.64 12.748.495-1.523 1.097-2.953 1.593-4.477.39.053.785.055 1.175.005l.603-1.407.169 1.348c1.87-.163 4.644-.52 6.416-.849l-.172-1.034 1.031.86c.544-.125.866-.239.84-.325 1.318 2.125 2.625 3.483 3.943 5.608.5-2.998 1.384-5.49-.3-8.225z"
        fill="#2F2E41"
      />
      <Path d="M180.436 93.224h-37.499v17.788h37.499V93.224z" fill="#fff" />
      <Path
        d="M173.345 96.95h-23.317v2.132h23.317V96.95zM173.345 101.051h-23.317v2.133h23.317v-2.133zM173.345 105.153h-23.317v2.133h23.317v-2.133z"
        fill="#E6E6E6"
      />
      <Path
        d="M110.281 97.449l-1.22-2.113-1.22-2.112-1.22 2.112-1.219 2.113h1.31v6.118h2.258v-6.118h1.311z"
        fill="#fff"
      />
      <Path
        d="M192.933 140.98c5.547 0 10.044-4.497 10.044-10.044 0-5.547-4.497-10.044-10.044-10.044-5.547 0-10.044 4.497-10.044 10.044 0 5.547 4.497 10.044 10.044 10.044z"
        fill="#3F3D56"
      />
      <Path
        d="M194.759 135.388a4.451 4.451 0 10-.001-8.903 4.451 4.451 0 00.001 8.903z"
        fill="#E6E6E6"
      />
      <Path
        d="M186.598 137.957l21.914 9.131-.685 2.168-12.612-1.427-21.343-9.473 11.87 1.37.856-1.769z"
        fill="#3F3D56"
      />
      <Path
        d="M205.969 146.676l27.255-89.404 6.637-11.787.023-.114c.022-.104.509-2.567-.69-4.352a3.905 3.905 0 00-2.639-1.662c-3.663-.687-11.858-1.025-12.205-1.04l-.065-.002-.065.009c-.224.03-5.462.796-6.645 5.37l-5.698 10.37-.023.073-25.794 84.802 1.419.432 25.772-84.728 5.717-10.405.024-.096c.837-3.442 4.839-4.247 5.371-4.339.837.036 8.54.379 11.918 1.012a2.446 2.446 0 011.678 1.027c.739 1.094.554 2.705.489 3.128l-6.596 11.714-.024.078-27.278 89.481 1.419.433z"
        fill="#3F3D56"
      />
      <Path
        d="M209.954 62.637l-.264 1.46 19.684 3.555.264-1.46-19.684-3.555zM206.278 74.78l-.297 1.453 19.544 3.989.297-1.454-19.544-3.989zM199.732 96.496l-.409 1.427 19.081 5.459.408-1.426-19.08-5.46zM212.636 138.589l.541-1.381-18.521-7.252-.909-9.847 17.286 6.456 5.6 8.103 1.221-.844-5.866-8.486-19.936-7.447 1.211 13.113 19.373 7.585z"
        fill="#3F3D56"
      />
      <Path
        d="M219.07 150.568c5.547 0 10.044-4.497 10.044-10.044 0-5.547-4.497-10.044-10.044-10.044-5.547 0-10.044 4.497-10.044 10.044 0 5.547 4.497 10.044 10.044 10.044z"
        fill="#3F3D56"
      />
      <Path
        d="M221.695 145.431a4.451 4.451 0 10.001-8.903 4.451 4.451 0 00-.001 8.903z"
        fill="#E6E6E6"
      />
    </Svg>
  );
}

export default NoOrdersGraphic;
